import React, { useState } from "react"

import * as styles from "../styles/post-toc.module.css"

const PostToc = ({ toc }) => {
  const [tocIsOpen, setTocIsOpen] = useState(true)
  const tocHandler = () => {
    setTocIsOpen(prevState => !prevState)
  }

  return (
    <div className={styles.toc}>
      <div className={styles.toc__title}>
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16}>
          <g fill="#444">
            <path d="M15 7H1c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1z" />
            <path d="M15 1H1c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1zM15 13H1c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1z" />
          </g>
        </svg>
        もくじ
        <button className={styles.toc__btn} onClick={tocHandler} type="button">
          {tocIsOpen ? "閉じる" : "開く"}
        </button>
      </div>
      {tocIsOpen && (
        <div
          className={styles.toc__list}
          dangerouslySetInnerHTML={{
            __html: toc,
          }}
        />
      )}
    </div>
  )
}

export default PostToc
